import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>About</h3>
          <p>Plur is a modern lifestyle brand dedicated to intimate wellness, sensual exploration, and personal connection.</p>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <p>Email: support@p1ur.com</p>
        </div>
        <div className="footer-section">
          <h3>Adult Disclaimer</h3>
          <p>This website contains adult-oriented content and products intended strictly for individuals 18 years of age or older.</p>
          <p>If you are under 18, please leave this website immediately.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
